import React, { useState, useEffect } from "react";

import { DonutLarge, Chat, MoreVert, Search } from "@material-ui/icons";

import ChatList from "../../components/Chat";
// import UserProfile from "../UserProfile";
import ChatWindow from "../../components/Window";
import NewChat from "../../components/NewChat";
import { Link, useNavigate } from 'react-router-dom';
//import User from "../../assets/img/Dodo_02.png";


import "./style.css";
import AppBar from "../../components/AppBar";
import ChatBotChannel from "../../components/ChatBotChannel";
import dodoImage from "../../assets/img/dodo_image.png";
import logoImg from "../../assets/img/logo2.png";
import { BsArrowLeftShort, BsPower} from 'react-icons/bs';


export default function ChatPage(){
    const navigate = useNavigate();

	const [user, setUser] = useState({
		id: 1234,
		avatar: "../../assets/img/dodo_image1.png",

	});


	const [chatList, setChatList] = useState([
		{
			chatId: 1,

			title: "Caio Agia",
			image: "https://avatars2.githubusercontent.com/u/56451511",

			title: "Shin Li",
			image: 'https://i.pravatar.cc/300',
		},
	]);

	const [activeChat, setActiveChat] = useState({});
	const [showNewChat, setShowNewChat] = useState(false);

	function handleLogout(){
		localStorage.clear();
  
		navigate('/');
	}

	return (
		<div className="chat-page-container">
			<AppBar/>
						
			<div className="container">

				<div className="sidebar">
				
					<div className="profile">
						{chatList.map((item, key) => (
							<Link to={"/profile"}>
								<ChatList
									key={key}
									data={item}
									active={activeChat.chatId === chatList[key].chatId}
									onClick={() => setActiveChat(chatList[key])}
								/>
							</Link>
						))}
					</div>

					<div className="row">
						<div className="newChat--list">
							<div className="text-center prymary-color mt-1">Medicamentos</div> 
							<div className="newChat--item" >
							
								<table class="table table-striped">
									<thead>
										<tr>

											<th scope="col">Nome</th>
											<th scope="col">Dose</th>
											<th scope="col">Freq.</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<th scope="row">Amlodipina </th>
											<td>20 mg</td>
											<td>1 x dia</td>
										
										</tr>
										<tr>
										<th scope="row">Clonazepam</th>
											<td>10 ml 0.25% </td>
											<td>7 gotas x dia VO</td>
								
										</tr>
										<tr>
										<th scope="row">Hidroclorotiazida</th>
											<td>25  mg</td>
											<td>1 x dia VO</td>
										</tr>
										<tr>
										<th scope="row">Diclofenaco</th>
											<td>100  mg</td>
											<td>SOS</td>
										</tr>
										<tr>
										<th scope="row">Clorofenamina</th>
											<td>4  mg</td>
											<td>1 x dia VO</td>
										</tr>
											<tr>
										<th scope="row">Lamotrigina</th>
											<td>100  mg</td>
											<td>2 x dia VO</td>
										</tr>
										
									</tbody>
								</table>
								
							</div>
							
						</div>
				
					</div>


					<div className="row">
						<div className="text-center">Cuidador:Pedro Gonçalves</div>
						<div className=" text-center">
							Contacto: 
							<a  className="prymary-color "  href="tel:351 255 258 258"> 
								+351 255 258 258
							</a>
						</div>
					</div>
				
				</div>

				<div className="contentarea">
					<div className="chatWindow--header">
						<div className="chatWindow--headerinfo">
							<img
								className="chatWindow--avatar"
								src={dodoImage}
								alt="dodo"
							/>
							<div className="chatWindow--name">Dodo</div>
						</div>

						<div className="chatWindow--headerbuttons">
							
							<div className="chatWindow--btn">
								<Link to ={""}>
									<MoreVert style={{ color: "#919191" }} />
								</Link>
			
							</div>
						</div>
					</div>
					<div className="chatcontentarea">

						<ChatBotChannel />

					</div>
				</div>


			</div>
			
	
		</div>

	);

};

